export enum TrafficSources {
  NoSource = 'No source',
}
